<template>
    <b-modal v-model="modal.show"
             hide-footer
             centered
             title="Crear cargo"
    >
        <b-form @submit.prevent="validateForm()"
                data-vv-scope="positions"
        >
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <label for="name">Nombre</label>
                        <el-input id="name"
                                  name="name"
                                  size="small"
                                  v-model="position.name"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:255'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('positions.name')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="description">Descripción</label>
                        <el-input id="description"
                                  name="description"
                                  size="small"
                                  type="textarea"
                                  v-model="position.description"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:255'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('positions.description')"
                        />
                    </b-form-group>
                </b-col>
            </b-row>


            <b-row>
                <div class="w-100 text-center">
                    <hr/>

                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="validateForm()"
                    >
                        <i class="fa fa-save"/> Guardar
                    </b-btn>
                    <b-btn variant="secondary"
                           class="mx-1"
                           size="sm"
                           @click="setModalShow(false)"
                    >
                        <i class="fa fa-close"/> Cancelar
                    </b-btn>
                </div>
            </b-row>
        </b-form>

    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('positions', [
            'position',
            'modal',
        ]),
        ...mapState('analysis', [
            'tarea'
        ]),
    },
    methods: {
        ...mapActions('positions', [
            'savePosition',
        ]),
        ...mapMutations('positions', [
            'setModalShow'
        ]),
        ...mapActions('analysis', [
            'getPositions'
        ]),
        validateForm() {
            this.$validator.validateAll('positions')
                .then(async (result) => {
                    if (result) {
                        await this.savePosition(this.tarea.id_empresa);
                        await this.getPositions();
                    }
                });
        }
    },
};
</script>

<style scoped>

</style>
